import { ApiPermissions } from '@constants/api-permissions';
import FlatButton from '@components/flat-button/flat-button';
import { usePermissions } from '@hooks/usePermissions';
import CustomInput from '@components/custom-input/custom-input.component';

type Props = {
    onCreateService?: () => void;
    onFilter?: (text: string) => void;
};

const ServiceActionList = ({ onCreateService, onFilter }: Props) => {
    const { hasPermission } = usePermissions();

    const isAllowed = hasPermission(ApiPermissions.CREATE_SERVICES);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 16,
            }}
        >
            <div style={{ width: 200 }}>
                <CustomInput
                    placeholder="Buscar servicio"
                    width="100%"
                    onChange={onFilter}
                />
            </div>
            <FlatButton onClick={onCreateService} disabled={!isAllowed}>
                + Añadir servicio
            </FlatButton>
        </div>
    );
};

export { ServiceActionList };
